import { useTranslation } from 'react-i18next';
import AreaPricingSettingsCard from '../../components/settings/area-pricing-card.tsx';
import { SettingsLeafPage } from '../../components/settings/settings-leaf-page.tsx';

/** Settings › Pricing & quotes › Size pricing: only this card, so only its reads run. */
export default function PricingAreaPage() {
  const { t } = useTranslation();
  return (
    <SettingsLeafPage
      title={t('settings.pricingPages.tiles.area.title')}
      back={{ to: '/settings/pricing', label: t('settings.pricingPages.backToPricing') }}
    >
      <AreaPricingSettingsCard />
    </SettingsLeafPage>
  );
}
